import { Injectable, signal } from '@angular/core';

/** localStorage key for the shell Auto-Process toggle. */
export const AGENT_AUTO_PROCESS_STORAGE_KEY = 'eventq:agent-auto-process';

function readStoredAutoProcess(): boolean {
  return localStorage.getItem(AGENT_AUTO_PROCESS_STORAGE_KEY) === 'true';
}

/** Global agent UI preferences (not tab-scoped). */
@Injectable({ providedIn: 'root' })
export class AgentPreferencesService {
  readonly autoProcess = signal(readStoredAutoProcess());

  setAutoProcess(enabled: boolean): void {
    this.autoProcess.set(enabled);
    localStorage.setItem(AGENT_AUTO_PROCESS_STORAGE_KEY, enabled ? 'true' : 'false');
  }

  /** Clears the preference so the next agent on this browser starts with it off. */
  resetAutoProcess(): void {
    this.autoProcess.set(false);
    localStorage.removeItem(AGENT_AUTO_PROCESS_STORAGE_KEY);
  }
}
